import Vue from 'vue';
import Rollbar from 'rollbar';
import * as ValidationRules from './libs/validation-rules';
import lang from './libs/lang';
import FeatureTogglePlugin from './libs/pdc-feature-toggle-vue';
import App from './App.vue';
import { formatDuration, formatPhoneNumber } from './libs/formatters';
import EventBus from './libs/EventBus';
import vuetify from './plugins/vuetify';
import version from '../version.json';
// eslint-disable-next-line no-unused-vars
import components from './libs/components'; // loads all global components

Vue.prototype.GOOGLE_TRACKING_CODE = process.env.VUE_APP_GOOGLE;
Vue.prototype.$global_emitter = EventBus;
Vue.prototype.$l = lang;

Vue.prototype.$validation = ValidationRules;

// rollbar - https://docs.rollbar.com/docs/vue-js
const rollbar_payload = {
  environment: process.env.VUE_APP_STAGE,
  client: {
    javascript: {
      code_version: version.latest_version,
    }
  },
};
Vue.prototype.$rollbar = new Rollbar({
  autoInstrument: { log: false },
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: rollbar_payload,
  enabled: !!process.env.VUE_APP_ROLLBAR_TOKEN
});
// eslint-disable-next-line no-unused-vars
Vue.config.errorHandler = (err, vm, info) => {
  if (err && err.message && err.message.includes('Avoided redundant navigation to current location')) return null;
  if (vm.$rollbar.enabled) {
    vm.$rollbar.configure({
      payload: {
        ...rollbar_payload,
        person: {
          id: vm.$session && vm.$session.user ? vm.$session.user.id : null,
          name: vm.$session && vm.$session.user && vm.$session.user.account ? vm.$session.user.account.name : null,
          email: vm.$session && vm.$session.user && vm.$session.user.account && vm.$session.user.account.contact ? vm.$session.user.account.contact.primary_email : null,
        },
        fullstory_url: (window.FS && typeof window.FS.getCurrentSessionURL === 'function') ? window.FS.getCurrentSessionURL() : 'Not available',
      },
    });
    vm.$rollbar.error(err);
  }
  throw err; // rethrow
};
Vue.config.productionTip = false;

Vue.use(FeatureTogglePlugin);

Vue.filter('formatDuration', formatDuration);
Vue.filter('formatPhoneNumber', formatPhoneNumber);

new Vue({
  render: (h) => h(App),
  vuetify,
}).$mount('#app');
